import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "Docs-Api" }
const _hoisted_2 = { class: "mb-16" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      (!_ctx.isIndexRoute)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "no-underline",
            to: _ctx.indexRoute
          }, {
            default: _withCtx(() => [
              _createTextVNode("API")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, "API")),
      (!_ctx.isIndexRoute)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " / " + _toDisplayString(_ctx.apiName), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        ref: "descriptionElement",
        innerHTML: _ctx.description
      }, null, 8 /* PROPS */, _hoisted_5)
    ])
  ]))
}